<h1>
    Descargar
</h1>
<p>Repositorio en github: <a href="https://github.com/LURMORENO/easier">https://github.com/LURMORENO/easier</a> </p>
<h2>Extensiones navegador</h2>
<p>
    Utilizar la extensión de EASIER es muy sencillo:
</p>
<ol>
<li>
    Primero, descarga la extensión para tu navegador Google Chrome o Mozilla Firefox.
</li>
<li>
    Una vez instalado, visita una página web y selecciona el texto que desees. 
</li>
<li>
    Luego, pulsa del botón derecho del ratón y selecciona la opción easier dentro del menú.
</li>
<li>
    Las palabras complejas aparecerán en <span class="word">azul</span>. 
</li>
</ol>